// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production: false,
    // apiUrl: 'https://api.golfdigg.com/golfdigg',
    apiUrl: 'https://devapi.golfdigg.com/golfdigg',
    // apiUrl: 'http://127.0.0.1:8080/golfdigg',
    // apiUrl: 'http://35.240.225.133:8080/golfdigg',

    nestApiUrl: 'https://nest-api-dev.golfdigg.com',
    // nestApiUrl: 'http://127.0.0.1:8080',

    // api3Url: 'https://api3.golfdigg.com',
    api3Url: 'https://devapi3.golfdigg.com',
    // api3Url: 'http://127.0.0.1:8081',

    apiGolfBag: 'https://golf-bag-api-dev.golfdigg.com',

    zoningByGPS: false,
    cache: {
        course: false,
        shop: false,
        package: false,
    },
    topGolfShopId: '64c2b4286dedc8456c54c2d4',
    transferNotifyEmail: 'sedtawut@golfdigg.com',
    versions: {
        userLevel: 3,
    }
};


